import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-gray-50 to-gray-200 text-gray-800">
      {/* Big 404 */}
      <h1 className="text-[8rem] font-extrabold text-indigo-600 drop-shadow-lg">404</h1>

      {/* Subtitle */}
      <h2 className="text-2xl md:text-3xl font-semibold mt-4">
        Oops! Page not found
      </h2>

      {/* Description */}
      <p className="mt-2 text-gray-500 text-center max-w-md">
        The page you are looking for might have been removed, had its name
        changed, or is temporarily unavailable.
      </p>

      {/* Back button */}
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 px-6 py-3 text-white bg-indigo-600 hover:bg-indigo-700 rounded-lg shadow-md transition duration-300"
      >
        <FaArrowLeft /> Back to Home
      </Link>
    </div>
  );
};

export default NotFoundPage;
